import { useMemo } from 'react';

export const useOrderItems = (items, order) => {
    return useMemo(() => {
        if (items && items.length > 0) {
            return items;
        }
        if (order) {
            if (order.items && order.items.length > 0) {
                return order.items;
            }
            if (order.details && order.details.items && order.details.items.length > 0) {
                return order.details.items;
            }
        }
        return [];
    }, [items, order]);
};